import { faChevronLeft, faSliders } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useStoreContext } from "../../contexts/store.context";

export const FiltersToggle = () => {
    const { showFilters, setShowFilters } = useStoreContext();
    const toggleFilters = () => {
        setShowFilters(current => !current);
    }
    return <button className="hidden md:flex flex-row items-center gap-2 border border-white/30 py-2 px-4 rounded" onClick={toggleFilters}>
        <FontAwesomeIcon icon={showFilters ? faChevronLeft : faSliders} />
        <div>Filters</div>
    </button>
}